import { useEffect, useRef, useState } from 'react';
import Search from "components/Organizacion/Search/OrganizationSearch";
import Form from "components/Organizacion/Form/OrganizationForm";
import Table from "components/Organizacion/Table/OrganizationTable";
import { useOrganizations } from 'hooks/useOrganization';

import { Modal } from "react-bootstrap";
import SpinnerBootrap from 'components/SpinnerBootrap';

function Organizacion() {

    const [modalClientes, setModalClientes] = useState(false);
    const [selectedOrganizacion, setSelectedOrganizacion] = useState(null);

    const {
        organizations,
        loading,
        page,
        totalPages,
        status,
        deleteOrganization,
        updateOrganization,
        createOrganization,
        getOrganizations,
        setPage,
        itemsPerPage,
        setItemsPerPage,
        totalOrganizations
    } = useOrganizations();

    const [isSearched, setIsSearched] = useState({
        search: '',
        option: '',
        state: false
    });

    const searchFormRef = useRef();

    const resetSearch = () => {
        setIsSearched({
            search: '',
            option: '',
            state: false
        });

        searchFormRef.current?.reset();
        getOrganizations({});
    };

    /**
     Manejo de sesión — mejor hacerlo global,
     pero por ahora sirve.
    */
    useEffect(() => {
        if (status === 401) {
            localStorage.removeItem('token');
            window.location.href = "/login";
        }
    }, [status]);

    return (
        <div className="container">

            <div className="row my-md-4">

                <h4 className="d-flex justify-content-center">
                    Gestor de Organizaciones
                </h4>

                {/* SEARCH */}
                <div className="col-12">
                    <Search
                        getOrganizations={getOrganizations}
                        setIsSearched={setIsSearched}
                        formRef={searchFormRef}
                    />
                </div>

                {/* FORM */}
                <div className="col-12">
                    <Form
                        createOrganization={createOrganization}
                        updateOrganization={updateOrganization}
                        setIsSearched={setIsSearched}
                        selectedOrganizacion={selectedOrganizacion}
                        setSelectedOrganizacion={setSelectedOrganizacion}
                    />
                </div>

                {/* TABLE */}
                <div className="col-12">

                    {loading && <SpinnerBootrap />}

                    <Table
                        organizations={organizations}
                        deleteOrganization={deleteOrganization}
                        getOrganizations={getOrganizations}
                        totalPages={totalPages}
                        setPage={setPage}
                        page={page}
                        isSearched={isSearched}
                        setIsSearched={setIsSearched}
                        hasSearched={isSearched.state}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        resetSearch={resetSearch}
                        totalOrganizations={totalOrganizations}
                        setSelectedOrganizacion={setSelectedOrganizacion}
                        openClientesModal={() => setModalClientes(true)}
                    />

                </div>
            </div>

            {/* MODAL FUTURO → Vincular clientes */}
            <Modal
                show={modalClientes}
                onHide={() => setModalClientes(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Vinculación con Clientes
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Aquí luego conectas useCliente
                    usando selectedOrganizacion
                </Modal.Body>

            </Modal>

        </div>
    );
}

export default Organizacion